import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from 'ngx-translate-with-country';
import { BreadcrumbsService } from 'ng6-breadcrumbs';
import { Title } from '@angular/platform-browser';
import { ContactService } from '../../_services/contact.service';
import { PageService } from '../../_services/page.service';
import { SimpleSmoothScrollService } from 'ng2-simple-smooth-scroll';
import { CategoryService } from '../../_services/category.service';
import { LocationService } from '../../_services/location.service';
import { ProductService } from '../../_services/product.service';
import { ProductRegisterService } from '../../_services/product-register.service';
import { Router } from '@angular/router';

declare var $: any;


@Component({
  selector: 'app-support-container',
  templateUrl: './support-container.component.html',
  styleUrls: ['./support-container.component.scss']
})
export class SupportContainerComponent implements OnInit {
  country: string;
  language: string;
  id: number;
  model: any = {};
  ids = [];
  faqKeys = [];
  categoriesArray: any;
  page: any;
  newpage: any;
  faqObject: any;
  customText: any;
  faq: any;
  newFaq: any;
  frameUrl: string = 'https://www.register-appliances.com/support/register-product';
  yt = '<iframe width="500px" height="2080px" frameBorder="0" src="https://www.register-appliances.com/support/register-product"></iframe>';
  new: any;
  selectedFaq: any;
  displayddl: string;
  countries: any;
  supportBanner: any;
  supportRegister: any;
  supportFind: any;
  manualCountry: any;
  manualCategory: any;
  manualProducts: any;
  manual: any;
  registerCountry: any;
  registerCategory: any;
  registerProducts: any;
  registerProduct: any;
  serialNumber: any;
  registerCountries: any;

  constructor(
    private locationService: LocationService,
    private categoryService: CategoryService,
    private productService: ProductService,
    private _contactService: ContactService,
    private translate: TranslateService,
    public titleService: Title,
    private route: ActivatedRoute,
    public breadcrumbsService: BreadcrumbsService,
    private _pageService: PageService,
    private smooth: SimpleSmoothScrollService,
    private productRegisterService: ProductRegisterService,
    private router: Router
  ) { }

  getCustomPages(country: string, language: string) {
    this._contactService.getCustomPages(country, language)
      .subscribe(
        resJSONData => {
          this.page = resJSONData[0];
          this.supportBanner = resJSONData[0].supportBanner.path;
          this.supportRegister = resJSONData[0].supportRegister.path;
          this.supportFind = resJSONData[0].supportFind.path;

        },
        error => console.log('Error ::' + error)
      );
  }

  getValueFromSelect(value: any) {
    this.selectedFaq = value;
    this.displayddl = 'none';
  }

  getFAQs(id: number, country: string, language: string): void {
    this._pageService.getFAQs(country, language)
      .subscribe(
        resultArray => {
          this.faq = resultArray;
          this.faqKeys = Object.keys(this.faq);
        },
        error => console.log('Error ::' + error)
      );
  }

  getCategories(country: string, language: string): void {
    this.categoryService.getCategories(country, language)
      .subscribe(
        resultArray => {
          this.categoriesArray = resultArray;
        },
        error => console.log('Error ::' + error)
      );

  }

  getLocation(countryParam: string, languageParam: string): void {
    console.log(countryParam, languageParam);
    this.locationService.getLocation(countryParam, languageParam).subscribe(
      response => {
        this.countries = response;
      },
      error => console.log('Error ::' + error)
    );
  }

  getRegisterCountries(countryParam: string, languageParam: string): void {
    this.locationService.getRegisterCountries(countryParam, languageParam).subscribe(
      response => {
        this.registerCountries = response;
      },
      error => console.log('Error ::' + error)
    );

  }

  goTop(){
    this.smooth.smoothScrollToTop({ duration: 1000, easing: 'linear' });
  }

  selectRegisterCountry(country) {
    this.registerCountry = country;

    if(this.registerCountry) {
      this.getRegisterProducts();
    }
  }

  selectRegisterCategory(category) {
    this.registerCategory = category;

    if(this.registerCountry) {
      this.getRegisterProducts();
    }
  }

  getRegisterProducts() {
    this.categoryService.getCategory(this.registerCategory,
      this.registerCountry, this.language)
      .subscribe(data => {
        this.registerProducts = data['products'];
      });
  }

  selectManualCountry(country) {
    this.manualCountry = country;

    if(this.manualCategory) {
      this.getManualProducts();
    }
  }

  selectManualCategory(category) {
    this.manualCategory = category;

    if(this.manualCountry) {
      this.getManualProducts();
    }
  }

  setRegisterProduct(link) {
    this.registerProduct = link;
  }

  continueRegister() {
    let product;
    let country;

    for(let i = 0; i < this.registerProducts.length; i++) {
      if(this.registerProducts[i].link == this.registerProduct) {
        product = this.registerProducts[i];
      }
    }

    for(let i = 0; i < this.countries.length; i++) {
      if(this.countries[i].code == this.registerCountry) {
        country = this.countries[i];
      }
    }

    let obj = {
      product: product,
      country: country,
      serialNumber: this.serialNumber
    };

    this.productRegisterService.product.next(obj);

    this.router.navigate(['/', this.country, this.language, 'register-product']);
  }

  getManualProducts() {
    this.categoryService.getCategory(this.manualCategory,
      this.manualCountry, this.language)
      .subscribe(data => {
        this.manualProducts = data['products'];
      });
  }

  getManual(link) {
    this.productService.getProduct(link, this.manualCountry, this.language)
    .subscribe(data => {
      for(let i = 0; i < data[0]['file'].length; i++) {
        if(data[0]['file'][i].typeCode == 'ib') {
          this.manual = data[0]['file'][i].path;
          break;
        }
      }
    });
  }

  ngOnInit() {

    this.smooth.smoothScrollToAnchor();

    this.route.params
      .subscribe(
        (params: Params) => {
          this.id = +params['id'];
          this.country = this.locationService.country;
          this.language = this.locationService.langCode;
          this.getCustomPages(this.country, this.language);
          this.getFAQs(this.id, this.country, this.language);
          this.getCategories(this.country, this.language);
          this.getRegisterCountries(this.country, this.language);
          this.getLocation(this.country, this.language);

          if(this.language == "en"){
            let url = "https://www.register-appliances.com/support/register-product"
          }else if(this.language == "uk"){
            let url = "https://www.register-appliances.com/support/register-product"
          }else{
            let url = "https://www.register-appliances.com/"+this.language+"/support/register-product"
          }


          //this.yt = '<iframe width="500px" height="2080px" frameBorder="0" src="'+url+'"></iframe>';




        }
      );
  }
}
